import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';
import { ActorCriteriaBucket, Criteria } from '@features/scenarios-browse/models/filter-criteria.model';
import { FilterBrowseService } from '@features/scenarios-browse/services/filter-browse.service';
import { inject } from '@angular/core';
import { FilterType } from '@features/scenarios-browse/enum/filter-criteria.enum';

interface FilterState {
  criterias: Criteria[];
  subCriterias: Criteria[];
  headerCriteria: Criteria;
  criteriaBucket: Criteria[];
  showHomePage: boolean;
}

const initialState: FilterState = {
  criterias: [] as Criteria[],
  subCriterias: [] as Criteria[],
  headerCriteria: {} as Criteria,
  criteriaBucket: [] as Criteria[],
  showHomePage: false,
};

export const FilterMenuStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, filterBrowseService = inject(FilterBrowseService)) => ({
    setCriterias(newCriterias: Criteria[]) {
      patchState(store, { criterias: newCriterias });
    },
    setSubCriterias(newCriterias: Criteria[]) {
      patchState(store, { subCriterias: newCriterias });
    },
    setHeaderCriteria(newCriteria: Criteria) {
      patchState(store, { headerCriteria: newCriteria });
    },
    setCriteriaBucket(newCriteriaBucket: Criteria[]) {
      patchState(store, { criteriaBucket: newCriteriaBucket });
    },
    getAllCriterias() {
      return [...store.criterias(), ...store.subCriterias(), store.headerCriteria()];
    },
    removeCriteriaFromBucket(index: number) {
      const criteriaBucket = store.criteriaBucket();
      criteriaBucket.splice(index, 1);
      patchState(store, { criteriaBucket: [...criteriaBucket] });
    },
    patchCriteriaBucket(newCriteria: Criteria) {
      let criteriaBucketToUpdate = store.criteriaBucket();
      criteriaBucketToUpdate = filterBrowseService.updateCriteriaWithinCriteriaList(
        criteriaBucketToUpdate,
        newCriteria,
      );
      patchState(store, { criteriaBucket: [...criteriaBucketToUpdate], showHomePage: false });
    },
    clearAllActorCriteriaInBucket() {
      patchState(store, {
        criteriaBucket: store.criteriaBucket().filter((criteria) => criteria.type !== FilterType.ACTOR),
      });
    },
    clearNoActorCriteriaInBucket() {
      patchState(store, {
        criteriaBucket: store
          .criteriaBucket()
          .filter(
            (criteria) =>
              criteria.type !== FilterType.ACTOR ||
              (criteria.type === FilterType.ACTOR && !(criteria as ActorCriteriaBucket).noActor),
          ),
      });
    },
    setShowHomePage: (showHomePage: boolean) => {
      patchState(store, { showHomePage: showHomePage });
    },
  })),
);
